<template>
    <v-dialog v-model="newFolderDialog" max-width="500" persistent>
        <template v-slot:activator="{ on: dialog }">
            <div v-on="{ ...dialog }" e2e-space-create-folder>
                <slot></slot>
            </div>
        </template>
        <v-card>
            <v-card-title class="flex-nowrap align-start">
                <div class="lighten-2 secondary--text">
                    <span>New Folder</span>
                </div>

                <v-spacer></v-spacer>
                <v-btn @click="newFolderDialog = false" icon><v-icon>clear</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <v-text-field
                    label="Folder name"
                    hide-details
                    v-model="folderName"
                    e2e-space-folder-input
                    autofocus
                    @keyup.enter="createFolder"
                    outlined></v-text-field>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn :disabled="!folderName.length" :loading="creatingFolder" @click="createFolder" text color="primary" e2e-space-folder-confirm>
                    create folder
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { enumsData } from '@/mixins/enums'

export default {
    name: 'CreateFolder',
    mixins: [enumsData],
    data: function () {
        return {
            newFolderDialog: false,
            folderName: '',
            creatingFolder: false
        }
    },
    props: {
        path: String,
        disabled: Boolean
    },
    methods: {
        createFolder() {
            this.creatingFolder = true
            const trimmedFolderName = this.folderName.trim()
            if (trimmedFolderName.length === 0) return
            const apiURL = this.path
            const postBody = {
                short_id: trimmedFolderName,
                long_id: trimmedFolderName,
                operation: 'CREATE'
            }
            this.$axios
                .post(apiURL, postBody)
                .then(({ data }) => {
                    if (data.collision_info.was_renamed) {
                        this.$store.dispatch('showSnackBar', {
                            snackBarText: 'Folder got renamed because of name collision! New name: <b>' + data.collision_info.final_name + '</b>',
                            snackBarTimeout: 10000,
                            snackBarIcon: 'info'
                        })
                    } else {
                        this.$store.dispatch('showSnackBar', {
                            snackBarText: 'Folder created successfully!',
                            snackBarTimeout: 5000,
                            snackBarIcon: 'check_circle'
                        })
                    }

                    this.$store.dispatch('snapshotStore/fetchCurrentFiles', { id: this.$route.params.snid, route: this.$route, setFetchingStatus: true })
                })
                .catch(() => {
                    this.$store.dispatch('showSnackBar', {
                        snackBarText: `Failed to create folder`,
                        snackBarTimeout: 10000,
                        snackBarIcon: 'error'
                    })
                })
                .finally(() => {
                    this.folderName = ''
                    this.newFolderDialog = false
                    this.creatingFolder = false
                })
        }
    }
}
</script>
